export default {
  "make-deposit_page-title_choose-type": "Which type of deposit would you like to make?",
  "make-deposit_label_one-time": "A One-Time Deposit",
  "make-deposit_desc_one-time": "A deposit will happen just once and will not repeat. It will post to your account near a date you choose.",
  "make-deposit_action_one-time": "Make a One-Time Deposit",
  "make-deposit_label_recurring": "A Recurring Deposit",
  "make-deposit_title_make-deposit": "Make a Deposit",
  "make-deposit_title_please-review": "Please review",
  "make-deposit_desc_recurring": "A deposit will happen on or near the same day every month without any more action on your part.",
  "make-deposit_action_recurring": "Setup a Recurring Deposit",
  "make-deposit_page-title_how-much-one-time": "How much would you like to deposit in your HSA account?",
  "make-deposit_page-title_how-much-recurring": "How much would you like to deposit in your HSA account each month?",
  "make-deposit_action_update": "Update Deposit",
  "make-deposit_action_submit": "Make Deposit",
  "make-deposit_account-label": " Account Ending in ",
  "make-deposit_text_success-message": "Success",
  "make-deposit_header-update-deposit": "Update Scheduled Deposit",
  "make-deposit_error-no-bank-heading": "No Bank Accounts",
  "make-deposit_error-no-bank-message": "You currently don't have any bank accounts. Would you like to add one?",
  "make-deposit_error-no-bank-action-label": "Add Bank Account",
  "make-deposit_error-no-hsa-heading": "No HSA Accounts",
  "make-deposit_error-no-hsa-message": "You currently don't have any HSA accounts.",
  "___make-deposit_title_confirm-close": "",
  "___make-deposit_text_confirm-close": "",
  "___make-deposit_action_confirm-close_cancel": "",
  "___make-deposit_action_confirm-close_confirm": "",
  "make-deposit_option_1st-of-month": "1st of Each Month",
  "make-deposit_option_5th-of-month": "5th of Each Month",
  "make-deposit_option_10th-of-month": "10th of Each Month",
  "make-deposit_option_15th-of-month": "15th of Each Month",
  "make-deposit_option_25th-of-month": "25th of Each Month",
  "make-deposit_text_refresh-data-error-message_add-deposit": "Your deposit has been added but we were unable to refresh the data on the screen. Please refresh the page.",
  "make-deposit_text_refresh-data-error-message_update-deposit": "Your deposit has been updated but we were unable to refresh the data on the screen. Please refresh the page.",

  // FULL SCREEN FLOW
  "make-deposit_step_select-type": "Select Type of Deposit",
  "make-deposit_step_how-much": "How Much to Deposit?",
  "make-deposit_step_review": "Please Review",

  // FORM LABELS
  "make-deposit_form-label_amount": "Amount",
  "make-deposit_form-label_bank-account": "Transfer From...",
  "make-deposit_form-label_expected-post-date": "Expected Post Date",
  "make-deposit_form-label_monthly-deposit-day": "Monthly Deposit Day",
  "make-deposit_form-label_tax-year": "Tax Year",
  "make-deposit_form-label_terms-and-conditions": "I understand it is my responsibility (1) to determine whether I am eligible to make contributions to my HSA and (2) to determine whether contributions to my HSA have exceeded the applicable maximum annual contribution limit. Deposits may not be available for immediate withdrawal until confirmed by my bank.",

  // FORM VALIDATION ERRORS
  "___make-deposit_form-error_expected-post-date_required": "",
  "___make-deposit_form-error_expected-post-date_date": "",
  "make-deposit_form-error_after-default-date": "Expected Post Date must be on or after %compareDate%.",
  "make-deposit_form-error_before-tax-year-end": "Expected Post Date must be on or before %compareDate%.",
  "make-deposit_form-error_after-current-date": "Expected Post Date must be in the future.",
  "make-deposit_form-error_before-group-migration": "Expected Post Date must be before the pending platform migration date of %compareDate%.",
  "make-deposit_form-error_first-pull-before-group-migration": "The first expected pull date must be before the pending platform migration date of %compareDate%.",
  "___make-deposit_form-error_terms-and-conditions_required": "",
  "make-deposit_form-error_amount_min-value": "Deposit amount must be greater than 0.",
  "make-deposit_form-error_amount_max-value": "Deposit amount must be less than $999,999,999,999.99.",
  "make-deposit_form-error_contribution-over-limit": "This contribution will put you over the maximum allowed by the IRS for the tax year.",
  "make-deposit_form-error_contribution-possibly-over-limit": "This contribution might put you over the maximum allowed by the IRS for the tax year. Do you want to continue?",
};